import { render, staticRenderFns } from "./AdminEW.vue?vue&type=template&id=053880ea&"
import script from "./AdminEW.vue?vue&type=script&lang=js&"
export * from "./AdminEW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports